import { defineStore, storeToRefs } from "pinia";
import api from "@/services/api";
import { useAuthStore, useSessionStore } from "@/stores";
import type IReplacementItem from "@/models/responses/IReplacementItem";

export const useReplacementItemsStore = defineStore("replacementitems", {
  state: () => ({
    error: "" as any,
    data: [] as IReplacementItem[],
    loadedTenantId: 0,
  }),
  actions: {
    async fetchAll(force = false) {
      const authStore = useAuthStore();
      const sessionStore = useSessionStore();

      const { isAuthenticated } = storeToRefs(authStore);
      const { selectedTenantId } = storeToRefs(sessionStore);

      if (!isAuthenticated.value) return;
      if (!force && this.loadedTenantId === selectedTenantId.value) return;

      this.error = "";
      await api
        .get<IReplacementItem[]>(`v1.0/replacement-items?tenantId=${selectedTenantId.value}`)
        .then((response) => {
          this.data = response.data;
          this.loadedTenantId = selectedTenantId.value;
        })
        .catch((error) => (this.error = error));
    },
  },
  getters: {
    getReplacementsForItem:
      (state) =>
      (itemId: number): IReplacementItem[] => state.data.filter((item) => item.itemId === itemId),
    getBaseItem:
      (state) =>
      (itemId: number): number | undefined => state.data.find((item) => item.replacementItemId === itemId)?.itemId,
  },
});
